<div class="one" fxLayout="column" [formGroup]="immigrationForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.VISATYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VISATYPE),
      }"
    >
      <mat-label>Visa Type</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.VISATYPE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="VISATYPE"
      />
      @if (testBool && toolTipList.VISATYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.VISATYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.VISATYPE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.VALUEOFASSETS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VALUEOFASSETS),
      }"
    >
      <mat-label>Assets</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.VALUEOFASSETS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="VALUEOFASSETS"
        [leadZero]="true"
      />
      @if (testBool && toolTipList?.VALUEOFASSETS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.VALUEOFASSETS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.VALUEOFASSETS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.VISASTATUS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VISASTATUS),
      }"
    >
      <mat-label>Visa Status</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.VISASTATUS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="VISASTATUS"
      />
      @if (testBool && toolTipList?.VISASTATUS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.VISASTATUS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.VISASTATUS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ANTICIPATEDDATEOFENTRY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ANTICIPATEDDATEOFENTRY),
      }"
    >
      <mat-label>Anticipated Entry</mat-label>
      <input
        (dateInput)="AnticipatedEntryClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.ANTICIPATEDDATEOFENTRY?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ANTICIPATEDDATEOFENTRYTEXT"
        (dateChange)="AnticipatedEntryClick('change', $event)"
        matInput
        [matDatepicker]="AnticipatedEntry"
      />
      <mat-datepicker-toggle matSuffix [for]="AnticipatedEntry"></mat-datepicker-toggle>
      <mat-datepicker #AnticipatedEntry></mat-datepicker>
      @if (testBool && toolTipList?.ANTICIPATEDDATEOFENTRY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ANTICIPATEDDATEOFENTRY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ANTICIPATEDDATEOFENTRY?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.LODGEMENTDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LODGEMENTDATE),
      }"
    >
      <mat-label>Lodgement Date</mat-label>
      <input
        (dateInput)="LodgementDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.LODGEMENTDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="LODGEMENTDATETEXT"
        (dateChange)="LodgementDateClick('change', $event)"
        matInput
        [matDatepicker]="LodgementDate"
      />
      <mat-datepicker-toggle matSuffix [for]="LodgementDate"></mat-datepicker-toggle>
      <mat-datepicker #LodgementDate></mat-datepicker>
      @if (testBool && toolTipList?.LODGEMENTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.LODGEMENTDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.LODGEMENTDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.VISAEXPIRYDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VISAEXPIRYDATE),
      }"
    >
      <mat-label>Visa Expiry Date</mat-label>
      <input
        (dateInput)="VisaExpiryDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.VISAEXPIRYDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="VISAEXPIRYDATETEXT"
        (dateChange)="VisaExpiryDateClick('change', $event)"
        matInput
        [matDatepicker]="VisaExpiryDate"
      />
      <mat-datepicker-toggle matSuffix [for]="VisaExpiryDate"></mat-datepicker-toggle>
      <mat-datepicker #VisaExpiryDate></mat-datepicker>
      @if (testBool && toolTipList?.VISAEXPIRYDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.VISAEXPIRYDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.VISAEXPIRYDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DECISIONDUEDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DECISIONDUEDATE),
      }"
    >
      <mat-label>Decision Due Date</mat-label>
      <input
        (dateInput)="DecisionDueDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.DECISIONDUEDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DECISIONDUEDATETEXT"
        (dateChange)="DecisionDueDateClick('change', $event)"
        matInput
        [matDatepicker]="DecisionDueDate"
      />
      <mat-datepicker-toggle matSuffix [for]="DecisionDueDate"></mat-datepicker-toggle>
      <mat-datepicker #DecisionDueDate></mat-datepicker>
      @if (testBool && toolTipList?.DECISIONDUEDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DECISIONDUEDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DECISIONDUEDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
